'use strict';
var $ = jQuery;

(function ($) {

  $(document).ready(function() {

      var $grid = $('.hjr-gallery');
      // Lightgallery: http://sachinchoolur.github.io/lightGallery/docs/api.html
      $grid.lightGallery({ 
        mode:'lg-slide',
        selector: 'a',
        loop: true,
        download: false,
        zoom:true,
        fullScreen:false,
        thumbnail:false,
        share:false,
        rotate:false,
        counter:false,
        autoplay:false,
        autoplayControls:false,
      });
  
    });
   
})(jQuery);
